// import Service from '../Service'
import AuthService from '../AuthService'

const FormRL = {
    saveRL01(data) {
        return AuthService.post('/api/rl-01', data).then(res => res)
    },
    saveRL02_1(data) {
        return AuthService.post('/api/rl-02-1', data).then(res => res)
    },
    saveRL02_2(data) {
        return AuthService.post('/api/rl-02-2', data).then(res => res)
    },
    saveRL02_3(data) {
        return AuthService.post('/api/rl-02-3', data).then(res => res)
    },
    saveRL03(data) {
        return AuthService.post('/api/rl-03', data).then(res => res)
    },
    saveRL04(data) {
        return AuthService.post('/api/rl-04', data).then(res => res)
    },
    saveRL05(data) {
        return AuthService.post('/api/rl-05', data).then(res => res)
    },
    saveRL06(data) {
        return AuthService.post('/api/rl-06', data).then(res => res)
    },
    saveRL07(data) {
        return AuthService.post('/api/rl-07', data).then(res => res)
    },
    saveRL08(data) {
        return AuthService.post('/api/rl-08', data).then(res => res)
    },
    saveRL09(data) {
        return AuthService.post('/api/rl-09', data).then(res => res)
    },
    saveRL10(data) {
        return AuthService.post('/api/rl-10', data).then(res => res)
    },
    getRL01(id) {
        return AuthService.get(`/api/rl-01/${id}`).then(res => res)
    },
    getRL02_1(id) {
        return AuthService.get(`/api/rl-02-1/${id}`).then(res => res)
    },
    getRL02_2(id) {
        return AuthService.get(`/api/rl-02-2/${id}`).then(res => res)
    },
    getRL02_3(id) {
        return AuthService.get(`/api/rl-02-3/${id}`).then(res => res)
    },
    getRL03(id) {
        return AuthService.get(`/api/rl-03/${id}`).then(res => res)
    },
    getRL04(id) {
        return AuthService.get(`/api/rl-04/${id}`).then(res => res)
    },
    getRL05(id) {
        return AuthService.get(`/api/rl-05/${id}`).then(res => res)
    },
    getRL06(id) {
        return AuthService.get(`/api/rl-06/${id}`).then(res => res)
    },
    getRL07(id) {
        return AuthService.get(`/api/rl-07/${id}`).then(res => res)
    },
    getRL08(id) {
        return AuthService.get(`/api/rl-08/${id}`).then(res => res)
    },
    getRL09(id) {
        return AuthService.get(`/api/rl-09/${id}`).then(res => res)
    },
    getRL10(id) {
        return AuthService.get(`/api/rl-10/${id}`).then(res => res)
    },
}

export default FormRL;
